import { siteConfig } from "../../content/site";

export function FinalCTA() {
  return (
    <section
      className="final-cta section section--compact"
      data-review-region="final-cta"
      aria-labelledby="final-cta-title"
    >
      <div className="section-shell final-cta__inner">
        <div className="final-cta__copy">
          <p className="section-kicker">まずは車の状態をお聞かせください</p>
          <h2 id="final-cta-title">
            <span>廃車の査定は電話で3分。</span>
            <span>分かる範囲で車の状態をお知らせください。</span>
          </h2>
          <p>
            沖縄本島全域に対応。レッカー代と抹消手続きは無料です。
            {siteConfig.serviceAreaNote}
            引き取り日時は地域・受付状況に応じて調整します。
          </p>
        </div>
        <div className="final-cta__action">
          <a className="button button--phone button--large" href={siteConfig.phoneHref}>
            今すぐ電話で3分査定
          </a>
          <strong>{siteConfig.phoneDisplay}</strong>
          <p>
            {siteConfig.contactNote}
            <span aria-hidden="true">／</span>
            {siteConfig.closedDay}
          </p>
          <p className="final-cta__prep">
            メーカー・車種、年式、状態、車がある市町村が分かるとご案内がスムーズです。
          </p>
        </div>
      </div>
    </section>
  );
}
